// extracted by mini-css-extract-plugin
export var circle = "Swatch-module--circle--82ed7";
export var isActive = "Swatch-module--isActive--fc3a4";
export var label = "Swatch-module--label--9058d";
export var swatch = "Swatch-module--swatch--b1063";
export var swatchWrap = "Swatch-module--swatchWrap--36761";